import axios from "axios";

const login = (username, password) => {
  let options = {
    'username': username, 
    'password': password
  };
  return axios
    .post(
      process.env.REACT_APP_API_BASE +
        'Authenticate', options, {
          headers: { 'content-type': 'application/json'},
        }
    )
    .then((response) => {
      if (response.data.access_token) {
        localStorage.setItem('token', JSON.stringify(response.data));
        localStorage.setItem('StarId', username);
        return axios
          .get(process.env.REACT_APP_API_BASE + 'voted/' + username, {
            headers: { Authorization: 'Bearer ' + response.data.access_token },
          })
          .then((res) => {
            if (res.data) {
              localStorage.setItem('studentVoted', true);
            }
          })
          .catch((error) => {
            console.log('error ', error);
            //localStorage.removeItem("token");
          });
      }
      return response.data;
    });
};

const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("options");
  localStorage.removeItem("StarId");
  localStorage.removeItem("studentVoted");
};

const getCurrentToken = () => {
  return JSON.parse(localStorage.getItem("token"));
};

const getCurrentUser= () => {
    return JSON.parse(localStorage.getItem("user"));
};

const getStarId= () => {
  return localStorage.getItem("StarId");
};

const alreadyVoted= () => {
  return JSON.parse(localStorage.getItem("studentVoted"));
};

const isAdmin= () => {
  return isTokenValid() && getCurrentToken().roles.includes('Admin');
};

const isStudent= () => {
  return isTokenValid() && getCurrentToken().roles.includes('Student');
};

const isCandidate= () => {
  return isTokenValid() && getCurrentToken().roles.includes('Candidate');
};

const reloadPageAlreadyVoted= () => {
  if (getCurrentToken().roles.includes('Admin')){
    return '/mock';
  } else {
    return '/validate';
  }
}

const reloadPage= () => {
  if (getCurrentToken().roles.includes('Admin')){
    return '/mock';
  } else {
    return '/';
  }
}

const isTokenValid = () => {
    const curToken = JSON.parse(localStorage.getItem("token"));
    if (curToken !== null) {
        if (curToken.expires >  Math.floor(Date.now() /1000)) {
            return true;
        } 
    }
    return false;
}

export default {
  login,
  logout,
  getCurrentToken,
  isTokenValid,
  getCurrentUser,
  reloadPageAlreadyVoted,
  reloadPage,
  isAdmin,
  isStudent,
  isCandidate,
  getStarId,
  alreadyVoted
};
